module.exports = __webpack_public_path__ + "static/media/bg-shape1.db5257ff.png";